import { Howl } from 'howler';

import AGUARDANDO_TRANSFERENCIA from 'assets/sounds/aguardando-transferencia.mp3';
import FILA_ESPERA_TIMEOUT from 'assets/sounds/fila-espera-timeout.mp3';
import FILA_ESPERA from 'assets/sounds/fila-espera.mp3';
import NOVA_MENSAGEM_CHAT_INTERNO from 'assets/sounds/nova-mensagem-chat-interno.mp3';
import NOVA_MENSAGEM_GRUPO from 'assets/sounds/nova-mensagem-grupo.mp3';
import NOVA_MENSAGEM from 'assets/sounds/nova-mensagem.mp3';
import { useAppSelector } from 'store';
import { mensagensSelector } from 'store/reducers/mensagens';

export const Sounds = {
  AGUARDANDO_TRANSFERENCIA,
  FILA_ESPERA,
  FILA_ESPERA_TIMEOUT,
  NOVA_MENSAGEM,
  NOVA_MENSAGEM_CHAT_INTERNO,
  NOVA_MENSAGEM_GRUPO,
};

export const useSound = () => {
  const { isGravandoAudio } = useAppSelector(mensagensSelector);

  const play = (src: string) => {
    if (isGravandoAudio) return;

    const howl = new Howl({ src, autoplay: false });
    howl.play();
  };

  return { play };
};
